// Subconjunto editorial: título, seções, parágrafos e listas numeradas.
// O leitor usa interpolação de texto; nunca executa HTML contido no Markdown.
export function helpMarkdownTitle(markdown) {
    const firstLine = markdown.replace(/^\uFEFF/, '').split(/\r?\n/).find(line => line.trim())?.trim();
    if (!/^# \S/.test(firstLine || '')) throw new Error('Artigo Markdown sem título.');
    return firstLine.slice(2).trim();
}

export function parseHelpMarkdown(markdown) {
    const lines = markdown.replace(/^\uFEFF/, '').replace(/\r\n/g, '\n').split('\n');
    helpMarkdownTitle(markdown);
    const sections = [];
    let section, paragraph = [];
    const sectionId = (title, explicitId) => {
        const base = explicitId || title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'secao';
        let id = base, suffix = 2;
        while (sections.some(item => item.id === id)) id = `${base}-${suffix++}`;
        return id;
    };
    const body = () => {
        if (!section) {
            section = { id: 'body', title: '', paragraphs: [] };
            sections.push(section);
        }
    };
    const flush = () => {
        if (paragraph.length) {
            body();
            section.paragraphs.push(paragraph.join(' ')); paragraph = [];
        }
    };
    for (const line of lines.slice(lines.findIndex(value => value.trim()) + 1)) {
        const heading = /^#{2,6} (.+)$/.exec(line.trim());
        if (heading) {
            flush();
            const explicit = /^(.*?) \{#([a-z0-9-]+)\}$/.exec(heading[1]);
            const title = explicit ? explicit[1] : heading[1];
            section = { id: sectionId(title, explicit?.[2]), title, paragraphs: [] };
            sections.push(section);
        } else if (!line.trim()) flush();
        else if (/^\d+\. /.test(line)) {
            flush();
            body();
            (section.steps ||= []).push(line.replace(/^\d+\. /, ''));
        } else {
            paragraph.push(line.trim());
        }
    }
    flush();
    if (!sections.length) throw new Error('Artigo sem conteúdo.');
    return sections;
}

export function serializeHelpMarkdown(article) {
    return '# ' + article.title + '\n\n' + article.sections.map(section =>
        (section.id === 'body' ? '' : `## ${section.title} {#${section.id}}\n\n`) +
        [...section.paragraphs, ...(section.steps?.length ? [section.steps.map((step, i) => `${i + 1}. ${step}`).join('\n')] : [])].join('\n\n')
    ).join('\n\n') + '\n';
}

export async function loadHelpMarkdown(readText) {
    const index = JSON.parse(await readText('index.json'));
    if (!Array.isArray(index.articles) || !index.articles.length || !Array.isArray(index.categories)) throw new Error('Índice da Ajuda inválido.');
    const ids = new Set();
    for (const article of index.articles) {
        if (!/^[a-z0-9-]+$/.test(article.id) || ids.has(article.id)) throw new Error('ID de artigo inválido.');
        ids.add(article.id);
    }
    const articles = await Promise.all(index.articles.map(async article => {
        try {
            const markdown = await readText(article.id + '.md');
            return { ...article, title: helpMarkdownTitle(markdown), sections: parseHelpMarkdown(markdown) };
        } catch {
            return { ...article, title: article.title || article.id, sections: [], unavailable: true };
        }
    }));
    return { ...index, articles };
}
